export const RTL_LANGUAGES = ['ar', 'ku', 'fa', 'yi', 'ps', 'ur', 'he'];
